import Vue from 'vue'
import Router from 'vue-router'

const index = resolve => require(['@/pages/index.vue'], resolve);
const kline = resolve => require(['@/pages/kline.vue'], resolve);
const result = resolve => require(['@/pages/result.vue'], resolve);

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/kline',
      name: 'kline',
      component: kline
    },
    {
      path: '/result',
      name: 'result',
      component: result
    },
    {
      path: '*',
      name: 'index',
      component: index
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js